import React from "react";

function Pagination({ totalPosts, postsPerPage, setCurrentPage, currentPage }) {
  let pages = [];

  for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
    pages.push(i);
  }

  return (
    <>
      <div className="bg-white p-4 flex items-center flex-wrap  justify-center">
        <nav aria-label="Page navigation">
          <ul className="inline-flex space-x-2">
            {pages.map((page, key) => (
              <li key={key}>
                <button
                  key={page}
                  onClick={() => {
                    setCurrentPage(page);
                    window.scrollTo({
                      top: 0,
                      left: 0,
                      behavior: "smooth",
                    });
                  }}
                  className={
                    page === currentPage
                      ? "rounded-lg h-8 px-3 text-white transition-colors duration-150 bg-[#294870] font-medium border border-r-0 border-[#345c91] focus:shadow-outline"
                      : "rounded-lg h-8 px-3 text-[#294870] transition-colors duration-150 focus:shadow-outline font-medium hover:bg-cyan-50"
                  }
                >
                  {page}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </>
  );
}

export default Pagination;
